import React from 'react'
import {Text, View} from '@react-pdf/renderer'
import {Title, LabeledInfo} from './common'
import styles from './styles'

export default function PlanInfo (plan) {

  const {
    translate,
    institution,
    author,
    planStart,
    planEnd,
    grade,
    subject,
    group,
    title = "",
    unit = "",
    lessons = [],
    resources = []
  } = plan

  return (<React.Fragment>
    <View style={styles.info} wrap={false}>
      <LabeledInfo label={translate('school')}>
        <Text style={styles.schoolName}>{institution.name}</Text>
      </LabeledInfo>
      <LabeledInfo label={translate('teacher')}>
        <Text style={styles.authorName}>{author.lastName}, {author.name}</Text>
      </LabeledInfo>
    </View>
    <Title title={translate('details-title')} />
    <View style={styles.info} wrap={false}>
      <LabeledInfo label={translate('assigned-date')}>
        {planStart == planEnd && (<Text>{`${planStart}`}</Text>)}
        {planStart != planEnd && (<Text>{`${planStart} - ${planEnd}`}</Text>)}
      </LabeledInfo>
      {group && (
        <LabeledInfo label={translate('group_label')}>
          <Text>{group.name}</Text>
        </LabeledInfo>
      )}
      {grade && (
        <LabeledInfo label={translate('grade')}>
          <Text>{grade.name}</Text>
        </LabeledInfo>
      )}
      {subject && (
        <LabeledInfo label={translate('subject')}>
          <Text>{subject.name}</Text>
        </LabeledInfo>
      )}
    </View>
    {title.length > 0 && (
      <View style={styles.info} wrap>
        <LabeledInfo label={translate('content-title')}>
          <Text>{title}</Text>
        </LabeledInfo>
      </View>
    )}
    {unit.length > 0 && (
      <View style={styles.info} wrap>
        <LabeledInfo label={translate('unit')}>
          <Text>{unit}</Text>
        </LabeledInfo>
      </View>
    )}
    {lessons.length > 0 && (
      <View style={styles.info} wrap>
        <LabeledInfo label={translate('lessons_label')}>
          {lessons.map(lesson => (<Text style={styles.lesson} key={lesson.id}>{`${lesson.id}: ${lesson.name}`}</Text>))}
        </LabeledInfo>
      </View>
    )}
    {resources.length > 0 && (
      <View style={styles.info} wrap>
        <LabeledInfo label={translate('digital-resources')}>
          {resources.map((resource, id) => {
            return (<Text style={styles.resources} key={id}>
              {resource.title}: {resource.href}
            </Text>)
          })}
        </LabeledInfo>
      </View>
    )}
  </React.Fragment>)
}
